import React, { Component } from 'react';
import { connect } from 'react-redux';

import LeaderboardsReport from './leaderboards';
import ForecastReport from './forecast';
import WhyWeWinReport from './whyWeWin';
import WinTheWeekReport from './winTheWeek';
import SprintHistoryReport from './sprintHistory';
import StrengthsReport from './strengths';

import {
  isProduction,
  isLocalhost,
  isDevelopment,
  currentUserIsAdmin,
  currentUserIsSalesLeader,
  getIcon,
} from '../../util';

class ReportsPage extends Component {

  state = {
    viewingReport: 'forecast'
  }

  viewReport(reportName){
    this.setState({
      viewingReport: reportName
    });
  }

  renderViewingReport(){
    const { viewingReport } = this.state;

    const { reportsRequireRole } = this.props.organization || {};

    const userCanViewReports = currentUserIsAdmin() || (reportsRequireRole && reportsRequireRole === 'salesleader' && currentUserIsSalesLeader());

    if(!userCanViewReports){
      return <div className="report-coming-soon">{getIcon('research')}<h3>Report in development</h3></div>
    }
    else if(viewingReport === 'leaderboards'){
      return <LeaderboardsReport />
    }
    else if(viewingReport === 'forecast'){
      return <ForecastReport />
    }
    else if(viewingReport === 'winTheWeek'){
      return <WinTheWeekReport />
    }
    else if(viewingReport === 'sprint'){
      return <SprintHistoryReport />;
    }
    else if(viewingReport === 'whywewin'){
      return <WhyWeWinReport />;
    }
    else if(viewingReport === 'strengths'){
      return <StrengthsReport />;
    }
    else{
      return <div className="report-coming-soon">{getIcon('research')}<h3>Report in development</h3></div>
    }
  }

  render(){

    const { viewingReport } = this.state;

    const {
      dealIQDisabled,
      coachingIQDisabled,
      assessmentIQDisabled,
    } = this.props.organization || {};

    return (
      <div className="page reports fs-block">
        <div className="report-chooser">
          <ul>
            {!dealIQDisabled &&
              <li className={`${viewingReport === 'forecast' ? 'active' : ''}`} onClick={() => { this.viewReport('forecast'); }}>{getIcon('forecast')}<span>Sales Forecast</span></li>
            }
            {!coachingIQDisabled &&
              <li className={`${viewingReport === 'leaderboards' ? 'active' : ''}`} onClick={() => { this.viewReport('leaderboards'); }}>{getIcon('sort')}<span>Activity Leaderboards</span></li>
            }
            {!coachingIQDisabled &&
              <li className={`${viewingReport === 'winTheWeek' ? 'active' : ''}`} onClick={() => { this.viewReport('winTheWeek'); }}>{getIcon('brief')}<span>Win The Week</span></li>
            }
            {!coachingIQDisabled &&
              <li className={`${viewingReport === 'sprint' ? 'active' : ''}`} onClick={() => { this.viewReport('sprint'); }}>{getIcon('sprint')}<span>Sprint History</span></li>
            }
            {!dealIQDisabled && currentUserIsAdmin() &&
              <li className={`${viewingReport === 'whywewin' ? 'active' : ''}`} onClick={() => { this.viewReport('whywewin'); }}>{getIcon('thumbs-up')}<span>Why We Win</span></li>
            }
            {!coachingIQDisabled && currentUserIsAdmin() &&
              <li className={`${viewingReport === 'strengths' ? 'active' : ''}`} onClick={() => { this.viewReport('strengths'); }}>{getIcon('summit')}<span>Strengths</span></li>
            }
          </ul>
        </div>
        {/*<h1>Sprint History Report</h1>*/}
        {this.renderViewingReport()}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps){
  return {
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, {})(ReportsPage);



// WEBPACK FOOTER //
// ./src/components/reports/index.js